export const MEMBER_POSITION = ['PM', '디자이너', '백엔드', '프론트엔드'];
